<form (ngSubmit)="confirm()" [attr.data-qa]="qaTag+ '-form'" class="form">
    <div class="modal-dialog">
        <h2 class="modal-dialog-title">{{ 'SWITCH_THEME_DIALOG.TITLE' | translate }}</h2>
        @for (themeIcon of themeIcons | keyvalue; track themeIcon.key) {
            @let theme = themeIcon.key;
            @let icon = themeIcon.value;
            <app-selection-form-item
                    (changed)="selectedTheme = theme"
                    [autoFocus]="true"
                    [checked]="selectedTheme === theme"
                    [class]="theme.toLowerCase()"
                    [id]="'theme-' + theme.toLowerCase()"
                    [qaTag]="qaTag + '-' + theme.toLowerCase()"
                    class="selection-form-item">
                <div class="theme-option-content">
                    <app-icon
                            [class]="theme.toLowerCase()"
                            [iconSize]="AppIconSizeEnum.SMALL"
                            [svgIcon]="icon"
                            aria-hidden="true"
                            class="theme-icon"/>
                    <span>{{ 'THEME.' + theme | translate }}</span>
                </div>
            </app-selection-form-item>
        }
        <div class="modal-dialog-action-text-buttons">
            <app-button [appButtonType]="AppButtonTypeEnum.TEXT_ONLY_BUTTON"
                        [buttonColor]="ButtonColorEnum.RED"
                        [buttonText]="'SWITCH_THEME_DIALOG.CONFIRM' | translate"
                        [buttonType]="ButtonTypeEnum.SUBMIT"
                        class="modal-dialog-action-button"
                        qaTag="switch-theme-dialog-confirm-button"/>
            <app-button (clicked)="cancel()"
                        [appButtonType]="AppButtonTypeEnum.TEXT_ONLY_BUTTON"
                        [buttonColor]="ButtonColorEnum.BLACK_WHITE"
                        [buttonText]="'BUTTON.CANCEL' | translate"
                        class="modal-dialog-action-button"
                        qaTag="switch-theme-dialog-cancel-button"/>
        </div>
    </div>
</form>
